<script setup lang="ts">
import ViewLayout from '@/views/layouts/ViewLayout.vue'
import MinersTable from '@/components/rc/tables/MinersTable.vue'
</script>

<template>
  <ViewLayout>
    <MinersTable />
  </ViewLayout>
</template>
